export default __webpack_public_path__ + "static/media/notif-sound.6ec09830.mp3";